<template>
<div id="updateSessionModal" class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ $t("session.update.title") }}</h5>
        <button type="button" class="btn-close" @click="cancel()" aria-label="Close"></button>
      </div>
      <div v-if="session" class="modal-body">
        <p>{{ $t("session.update.instructions") }}</p>
        <form @submit.prevent="">
          
            <div class="form-group mb-3">
              <label for="nameInput">{{ $t("session.update.nameLabel") }}</label>
              <input id="nameInput" type="text" class="form-control" :class="{ 'is-invalid': nameError}" v-model="session.name">      
              <div v-if="nameError" class="invalid-feedback">
                {{nameError}}
              </div>   
            </div>

            <div class="form-group mb-3">
              <label for="startDateInput">{{ $t("session.update.startDateLabel") }}</label>
              <input id="startDateInput" type="datetime-local" class="form-control" :class="{ 'is-invalid': startDateError}" v-model="session.startDate">      
              <div v-if="startDateError" class="invalid-feedback">
                {{startDateError}}
              </div>   
            </div>

            <div class="form-group mb-3">
              <label for="endDateInput">{{ $t("session.update.endDateLabel") }}</label>
              <input id="endDateInput" type="datetime-local" class="form-control" :class="{ 'is-invalid': endDateError}" v-model="session.endDate">      
              <div v-if="endDateError" class="invalid-feedback">
                {{endDateError}}
              </div>   
            </div>

            <div class="form-group mb-3">
              <label for="moduleInput">{{ $t("session.update.moduleLabel") }}</label>
              <select class="form-select form-select-sm"  v-model="session.module" :class="{ 'is-invalid': moduleError}">
                <option v-for="module in modules" v-bind:key="module.id" v-bind:value="module">{{ module.name }}</option>
              </select>
              <div v-if="moduleError" class="invalid-feedback">
                {{moduleError}}
              </div>   
            </div>

            
            <div v-if="error" class="alert alert-danger" role="alert">
              {{error}}
            </div>

            <div v-if="session.module" class="form-group mb-3">
              <label>{{ $t("session.update.template_custom_value_label") }}</label>
              <fieldset class="scheduler-border mt-3">
                
                <div v-for="(property, index) in session.module.properties" v-bind:key="index">
                  
                  <div class="form-outline mb-3" v-if="property.format == 'enum'">
                    <label>{{ property.label }}</label>
                    <select class="form-select form-select-sm" v-model="session.data[property.id]">
                      <option value="null">{{ $t("session.update.nullLabel") }}</option>
                      <option v-for="(value, indexVal) in property.values" v-bind:key="indexVal" v-bind:value="value.value">{{ value.label }}</option>
                    </select>
                  </div>
                                    
                  <div class="form-outline mb-3" v-if="property.format == 'string'">
                    <label>{{ property.label }}</label>
                    <textarea class="form-control" rows="3" v-model="session.data[property.id]"></textarea>
                  </div>

                  <div class="form-check form-switch mb-3" v-if="property.format == 'boolean'">
                    <input class="form-check-input" type="checkbox" :id="property.id" v-model="session.data[property.id]">
                    <label class="form-check-label" :for="property.id">{{ property.label }}</label>
                  </div>
                  
                </div>
              </fieldset>
            </div>            

          
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" @click="cancel()">{{ $t("session.update.closeLabel") }}</button>
        <button type="button" class="btn btn-primary" @click="updateSession()">{{ $t("session.update.updateLabel") }}</button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import moment from 'moment';
import {Modal} from 'bootstrap';
import $ from 'jquery'

import sessionService from '../../services/sessionService';
import eventConfig from '@/configs/eventConfig';
import moduleService from '@/services/moduleService';

const emptySession = {
      name: null,
      startDate: null,
      endDate: null,
      module: null,
      data: {}
     };

export default {
  name: 'SessionUpdateComponent',
  props: {
    sessionToUpdate: Object
  },
  watch: 
  { 
    sessionToUpdate: function() {
      if(this.sessionToUpdate)
      {
        this.loadModules();
        
      }
    }
  },
  data: function () {
    return {
      session: emptySession,
      updateModal: null,
      nameError: null,
      startDateError: null,
      endDateError: null,
      moduleError: null,
      error: null,
      modules: null
    }
  },
  components: {
    
  },
  mounted () {
    
    this.updateModal = new Modal($('#updateSessionModal'));
    
    this.eventDispatcher.on(eventConfig.UNAUTHORIZED, () => {
      this.cancel();
    });

  },
  methods: {
    timestamp(date) {
      return moment(date).format('YYYY-MM-DDTHH:mm');
    },
    loadModules()
    {
      moduleService.getList().then(
        response => {
     
          this.modules = response;
          
          this.session = JSON.parse(JSON.stringify(this.sessionToUpdate));
          this.session.startDate = this.timestamp(this.session.startDate);
          this.session.endDate = this.timestamp(this.session.endDate);
          if(!this.session.data)
          {
            this.session.data = {};
          }

          for(let module of this.modules)
          {
            if(module.id == this.session.module.id)
            {
              this.session.module = module;
            }
          }
          

          this.resetMessages();
          this.openModal();
        },
        errors => {
          
        }
      );
      
    },
    cancel()
    {
      this.updateModal.hide();
      this.$emit(eventConfig.CANCELED);
    },
    resetMessages()
    {
      this.nameError = null;
      this.startDateError = null;
      this.endDateError = null;
      this.moduleError = null;
      this.error = null;
    },    
    openModal() {
      this.updateModal.show();
    },
    updateSession() {
      
      this.nameError = null;
      this.startDateError = null;
      this.endDateError = null;
      this.moduleError = null;
      this.error = null;

      var session = JSON.parse(JSON.stringify(this.session));

      if(this.session.module)
      {
        session.module = this.session.module.id;
      }

      for (var key in session.data) 
      {
          if (session.data[key] == "null")
          {
            delete session.data[key];
          }
      }

      sessionService.update(session).then(
        response => {
          this.updateModal.hide();
          this.$emit(eventConfig.UPDATED);
        },
        errors => {
          this.parseErrors(errors.response.data);
        }
      );
      
    },
    parseErrors(data)
    {
      if(data.errors)
      {
        for(let error of data.errors)
        {
          
          switch(error.param)
          {
            case 'startDate':
              this.startDateError = (error.msg.msg_code) ? this.$t(error.msg.msg_code) : error.msg;
            break;
            case 'endDate':
              this.endDateError = (error.msg.msg_code) ? this.$t(error.msg.msg_code) : error.msg;
            break;
            case 'name':
              this.nameError = (error.msg.msg_code) ? this.$t(error.msg.msg_code) : error.msg;
            break;
            case 'module':
              this.moduleError = (error.msg.msg_code) ? this.$t(error.msg.msg_code) : error.msg;
            break;
          }
        }
      }else
      {
        this.error = (data.msg_code) ? this.$t(data.msg_code) : data.msg;
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '../../sass/variables.scss';

.scheduler-border {

  border: 1px solid #CCC;
  border-radius: 4px;
  padding: 20px;
}
</style>